(()=>{
  const KEY='auren_wishlist_v1';
  const HEART='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"/></svg>';
  let scheduled=false;

  function load(){
    try{
      const value=JSON.parse(localStorage.getItem(KEY)||'[]');
      return Array.isArray(value)?value:[];
    }catch(error){
      return [];
    }
  }

  function write(items){
    localStorage.setItem(KEY,JSON.stringify(items));
  }

  function save(items){
    write(items);
    sync();
  }

  function norm(url){
    try{
      return new URL(url,location.origin).pathname.replace(/\/$/,'');
    }catch(error){
      return url;
    }
  }

  function esc(value){
    return String(value||'').replace(/[&<>"']/g,char=>({
      '&':'&amp;',
      '<':'&lt;',
      '>':'&gt;',
      '"':'&quot;',
      "'":'&#039;'
    }[char]));
  }

  function primaryCardImage(card){
    const media=card.querySelector('.card__media,.card-media,.product-card__media,.product-card__image,[class*="card-media"],[class*="card__media"]')||card;
    const images=[...media.querySelectorAll('img')];
    const image=images.find(img=>!img.closest('[class*="secondary"],[class*="hover"]'))||images[0]||card.querySelector('img');
    return image?.getAttribute('src')||image?.src||'';
  }

  function itemFor(card,link){
    const title=card.querySelector('h1,h2,h3,.card__heading,.product-card__title,[class*="title"]');
    const price=card.querySelector('.price,[class*="price"]');
    return{
      url:norm(link.href),
      title:(title?.textContent||link.textContent||'Produkt').trim().replace(/\s+/g,' '),
      image:primaryCardImage(card),
      price:(price?.textContent||'').trim().replace(/\s+/g,' ')
    };
  }

  function active(url){
    return load().some(item=>norm(item.url)===norm(url));
  }

  function toggle(item){
    const items=load();
    const index=items.findIndex(entry=>norm(entry.url)===norm(item.url));
    if(index>-1)items.splice(index,1);
    else items.unshift(item);
    save(items);
  }

  function mediaFor(card,link){
    return card.querySelector('.card__media,.card-media,.product-card__media,.product-card__image,[class*="card-media"],[class*="card__media"]')||link.querySelector('img')?.closest('.media,picture,div')||link;
  }

  function enhanceCards(){
    document.querySelectorAll('product-card,.card-wrapper,.product-card,.product-grid__item,[data-product-id]').forEach(card=>{
      if(card.dataset.aurenWishlistReady)return;
      const link=card.querySelector('a[href*="/products/"]');
      if(!link)return;
      const media=mediaFor(card,link);
      if(!media)return;
      card.dataset.aurenWishlistReady='true';
      card.classList.add('auren-wishlist-card');
      media.classList.add('auren-wishlist-media');
      const button=document.createElement('button');
      button.type='button';
      button.className='auren-wishlist-card-button';
      button.dataset.url=norm(link.href);
      button.innerHTML=HEART;
      button.addEventListener('click',event=>{
        event.preventDefault();
        event.stopPropagation();
        toggle(itemFor(card,link));
      });
      media.appendChild(button);
    });
    updateButtons();
  }

  function findSearch(){
    const header=document.querySelector('header-component,#header-group,header');
    if(!header)return null;
    for(const selector of ['.header__icon--search','[href*="/search"]','button[aria-label*="sök" i]','button[aria-label*="search" i]','summary[aria-label*="sök" i]','summary[aria-label*="search" i]']){
      const found=header.querySelector(selector);
      if(found)return found.closest('a,button,summary')||found;
    }
    return null;
  }

  function addHeader(){
    if(document.querySelector('.auren-wishlist-header-button'))return;
    const search=findSearch();
    if(!search)return;
    const link=document.createElement('a');
    link.href='/pages/favoriter';
    link.className='auren-wishlist-header-button';
    link.setAttribute('aria-label','Visa favoriter');
    link.innerHTML=HEART+'<span class="auren-wishlist-count" aria-hidden="true"></span>';
    search.insertAdjacentElement('afterend',link);
    updateCount();
  }

  function productJsonUrl(url){
    return norm(url)+'.js';
  }

  function normalizeImageUrl(url){
    return url?.startsWith('//')?location.protocol+url:url;
  }

  async function correctFeaturedImage(item,imageElement){
    try{
      const response=await fetch(productJsonUrl(item.url),{headers:{Accept:'application/json'}});
      if(!response.ok)return;
      const product=await response.json();
      const featured=normalizeImageUrl(product.featured_image||(Array.isArray(product.images)?product.images[0]:'')||'');
      if(!featured)return;
      imageElement.src=featured;
      const items=load();
      const stored=items.find(entry=>norm(entry.url)===norm(item.url));
      if(stored&&stored.image!==featured){
        stored.image=featured;
        write(items);
      }
    }catch(error){
      // Keep the saved image if Shopify's product JSON can't be reached.
    }
  }

  function renderPage(){
    const grid=document.querySelector('[data-auren-wishlist-page]');
    if(!grid)return;
    const items=load();
    if(!items.length){
      grid.innerHTML='<div class="auren-wishlist-page__empty"><p>Du har inga sparade favoriter ännu.</p><a class="auren-wishlist-page__browse" href="/collections/all">Fortsätt handla</a></div>';
      return;
    }
    grid.innerHTML='';
    items.forEach(item=>{
      const article=document.createElement('article');
      article.className='auren-wishlist-page__item';
      article.innerHTML='<a class="auren-wishlist-page__image-wrap" href="'+esc(item.url)+'">'+(item.image?'<img class="auren-wishlist-page__image" src="'+esc(item.image)+'" alt="">':'')+'</a><a class="auren-wishlist-page__title" href="'+esc(item.url)+'">'+esc(item.title)+'</a><div class="auren-wishlist-page__price">'+esc(item.price||'')+'</div><button class="auren-wishlist-page__remove" type="button" data-url="'+esc(item.url)+'" aria-label="Ta bort '+esc(item.title)+'">×</button>';
      grid.appendChild(article);
      const image=article.querySelector('.auren-wishlist-page__image');
      if(image)correctFeaturedImage(item,image);
    });
  }

  function bindPage(){
    const grid=document.querySelector('[data-auren-wishlist-page]');
    if(!grid||grid.dataset.aurenWishlistBound)return;
    grid.dataset.aurenWishlistBound='true';
    grid.addEventListener('click',event=>{
      const button=event.target.closest('.auren-wishlist-page__remove');
      if(!button||!grid.contains(button))return;
      event.preventDefault();
      event.stopPropagation();
      const url=norm(button.dataset.url);
      save(load().filter(item=>norm(item.url)!==url));
    },true);
  }

  function updateButtons(){
    document.querySelectorAll('.auren-wishlist-card-button').forEach(button=>{
      const isActive=active(button.dataset.url);
      button.classList.toggle('is-active',isActive);
      button.setAttribute('aria-pressed',String(isActive));
      button.setAttribute('aria-label',isActive?'Ta bort från favoriter':'Lägg till i favoriter');
    });
  }

  function updateCount(){
    document.querySelectorAll('.auren-wishlist-count').forEach(count=>{
      const number=load().length;
      count.textContent=String(number);
      count.classList.toggle('has-items',number>0);
    });
  }

  function sync(){
    updateButtons();
    updateCount();
    renderPage();
  }

  function run(){
    scheduled=false;
    addHeader();
    enhanceCards();
    bindPage();
    updateButtons();
    updateCount();
  }

  function schedule(){
    if(scheduled)return;
    scheduled=true;
    requestAnimationFrame(run);
  }

  function init(){
    bindPage();
    renderPage();
    run();
    new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
    document.addEventListener('shopify:section:load',schedule);
    window.addEventListener('storage',event=>{
      if(event.key===KEY)sync();
    });
  }

  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init();
})();